import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { MultiSelect, Select, tokens } from '@treams/treams-ui';

const Container = styled(Box)``;

const Label = styled(Box)`
	color: ${tokens.text.secondary};
`;

function EmployeesSingleFilter(props: {
	name: string;
	label: string;
	options: {
		label: string;
		value: string;
	}[];
	search?: boolean;
}) {
	const { t } = useTranslation();

	const [field, , { setValue }] = useField<string>(props.name);

	const options = props.options.map(({ label, value }) => ({ title: label, value }));

	return (
		<Container mt={3}>
			<Label mb={1}>{props.label}</Label>
			<Select
				placeholder={t('ui.select.placeholder')}
				search={props.search}
				options={options}
				selectedOption={options.find(({ value }) => field.value === value)}
				onChange={(value) => setValue(value!)}
			/>
		</Container>
	);
}

function EmployeesMultiFilter(props: {
	name: string;
	label: string;
	options: {
		label: string;
		value: string;
	}[];
}) {
	const [field, , { setValue }] = useField<string[]>(props.name);

	const options = props.options.map(({ label, value }) => ({ title: label, value }));

	return (
		<Container mt={3}>
			<Label mb={1}>{props.label}</Label>
			<MultiSelect
				allowMultiSelect
				options={options}
				selectedOptions={options.filter(({ value }) => field.value.includes(value))}
				onChange={(values) => setValue(values)}
			/>
		</Container>
	);
}

export default function EmployeesFilter(props: {
	name: string;
	label: string;
	options: {
		label: string;
		value: string;
	}[];
	search?: false;
	single?: boolean;
}) {
	if (props.single) {
		return <EmployeesSingleFilter {...props} />;
	} else {
		return <EmployeesMultiFilter {...props} />;
	}
}
